export const dynamicLoadApiQueries = async httpClient => (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
  httpClient
});
export const dynamicLoadApiClient = async () => {
  return await import('../ApiClients/DomainsApiClient');
};
//# sourceMappingURL=dynamicLoadApiQueries.js.map